document.addEventListener("DOMContentLoaded", () => {
  let hostname = window.location.hostname;

  /* if (isChance60Percent()) {
    if (
      hostname.startsWith("m.diena.") ||
      hostname.startsWith("m.kauno.") ||
      hostname.startsWith("m.klaipeda.")
    ) {
      // Google anchor ad workaround
      checkElement(".grippy-host").then((grippy) => {
        let grippy_host_parent = grippy.parentNode;
        if (grippy_host_parent.getBoundingClientRect().top > 0) {
          grippy.classList.add("grippy-bottom");
        }
      });
    }
  } */
  /* grippy_host.forEach(grippy =>{
    let grippy_host_parent = grippy.parentNode;
    let parent_host_y_position = grippy_host_parent.getBoundingClientRect().top;
    if (parent_host_y_position >= 0) {
      grippy_host_parent.classList.add('grippy-bottom');
    }
  }); */
});

function isChance60Percent() {
  return Math.random() < 0.6;
}

//Use requestAnimationFrame to detect if element is 100% loaded in DOM
const checkElement = async (selector) => {
  while (document.querySelector(selector) === null) {
    await new Promise((resolve) => requestAnimationFrame(resolve));
  }
  return document.querySelector(selector);
};
